import { render, staticRenderFns } from "./OpenPort.vue?vue&type=template&id=231e4666&"
import script from "./OpenPort.vue?vue&type=script&lang=js&"
export * from "./OpenPort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports